import * as React from 'react';
import { MouseEvent } from 'react';
import * as _ from 'lodash';
import { styled } from '../../theme';
import { TableColumn, TableColumnStyle, TableRow } from './TableWidget';
import { css } from '@emotion/react';

export interface TableRowWidgetProps<T extends TableRow> {
  row: T;
  cols: TableColumn<T>[];
  onSelect?: (event: MouseEvent, row: T) => any;
}

export interface TableRowWidgetState {
  isHovering: boolean;
}

export class TableRowWidget<T extends TableRow = TableRow> extends React.Component<
  TableRowWidgetProps<T>,
  TableRowWidgetState
> {
  constructor(props: TableRowWidgetProps<T>) {
    super(props);
    this.state = {
      isHovering: false
    };
  }

  componentDidMount() {
    // Set the state to false every time it mounts for render
    this.setState({ isHovering: false });
  }

  handleOnMouseEnter = () => {
    this.setState({ isHovering: true });
  };

  handleOnMouseLeave = () => {
    this.setState({ isHovering: false });
  };

  render() {
    const { row } = this.props;
    return (
      <S.Row
        key={row.key}
        selectable={!!this.props.onSelect}
        active={this.state.isHovering}
        onClick={(event: any) => {
          if (this.props.onSelect) {
            event.persist();
            event.preventDefault();
            this.props.onSelect(event, row);
          }
        }}
        onMouseEnter={this.handleOnMouseEnter}
        onMouseLeave={this.handleOnMouseLeave}
      >
        {_.map(this.props.cols, (col, idx) => {
          return (
            <S.Cell mode={col.style || TableColumnStyle.NORMAL} key={`${col.key}-${idx}`} right={col.right!!}>
              {col.accessor?.({ cell: row.cells[col.key], row: row, active: this.state.isHovering })}
            </S.Cell>
          );
        })}
      </S.Row>
    );
  }
}

namespace S {
  export const Row = styled.tr<{ active?: boolean; selectable: boolean }>`
    &:nth-of-type(even) {
      background: ${(p) => p.theme.table.even};
    }

    &:nth-of-type(odd) {
      background: ${(p) => p.theme.table.odd};
    }

    ${(p) =>
      p.active
        ? css`
            background-color: ${p.theme.table.active};
          `
        : ''};

    :hover {
      background-color: ${(p) => p.theme.table.active};
    }

    cursor: ${(p) => (p.selectable ? 'pointer' : 'inherit')};
  `;
  export const Cell = styled.td<{ right: boolean; mode: TableColumnStyle }>`
    text-align: ${(p) => (p.right ? 'right' : 'left')};
    padding: 5px 10px;
    font-size: 15px;
    ${(p) => (p.mode === TableColumnStyle.SECONDARY ? 'opacity: 0.5' : '')};
    ${(p) => (p.mode === TableColumnStyle.PRIMARY ? 'font-weight: bold' : '')};
  `;
}
